module.exports = "\r\n\r\nh3 input {\r\n\tdisplay: inline-block; margin: 0 20px 0 10px;\r\n}\r\n"